import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';

import { Can, useAuth, Spinner } from '@iq/react-components';
import SwaggerUI from 'swagger-ui-react';
import config from '../../config';
import 'swagger-ui-react/swagger-ui.css';
import {
  getCollaborationServiceDocs,
  getAuthServiceDocs,
  getEventServiceDocs,
  getDataServiceDocs,
  getSiteServiceDocs,
  getFileServiceDocs,
  getModelServiceDocs,
  getIntegrationServiceDocs,
} from '../../services';
import { capitalize } from '../../utils';

const ApiDocView = ({
  match: {
    params: { id: service },
  },
}) => {
  const { getAccessToken } = useAuth();
  const [docs, setDocs] = useState();
  const [loading, setLoading] = useState(true);
  const serviceName = service.split('-')[0];
  let siteId = '';

  const { services } = config;

  const getEndpoint = () => {
    const endPointName = serviceName.split('-')[0];
    const [, { endpoint }] = Object.entries(services).find((i) => i.includes(endPointName));
    return endpoint;
  };

  const serviceEndpoints = {
    auth: getAuthServiceDocs,
    collaboration: getCollaborationServiceDocs,
    data: getDataServiceDocs,
    event: getEventServiceDocs,
    file: getFileServiceDocs,
    model: getModelServiceDocs,
    site: getSiteServiceDocs,
    integration: getIntegrationServiceDocs,
  };

  const getApiDocs = async (endpoint) => {
    const getServiceDocs = serviceEndpoints[serviceName];
    if (getServiceDocs) {
      try {
        const serviceDocs = await getServiceDocs();
        setLoading(false);
        if (serviceDocs) {
          const parsedDocsWithServer = { ...serviceDocs, servers: [{ url: `${endpoint}` }] };
          setDocs(parsedDocsWithServer);
        } else {
          throw new Error('Service docs not found');
        }
      } catch (error) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    const endpoint = getEndpoint();
    getApiDocs(endpoint);
  }, []);

  const getSiteId = (req) => {
    const url = new URL(req.url, window.location.origin);
    return url.searchParams.get('site') || 'unknown_site';
  };

  const handleBinaryResponse = (res, site, fileName) => {
    const contentType = res.headers['content-type'];
    if (
      contentType?.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
    ) {
      const blob = new Blob([res.data], { type: contentType });
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = `${site}-${fileName}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);

      res.data = null;
      res.text = '';
      return res;
    }
    return res;
  };

  if (loading) {
    return (
      <div className="docs-spinner">
        <Spinner />
      </div>
    );
  }

  if (docs && !loading) {
    return (
      <div>
        <div className="back-link">
          <NavLink
            title={'Back'}
            exact
            to={'/api-docs'}
          >
            {'< Back'}
          </NavLink>
        </div>

        <div className="items">
          <Can permission={`${serviceName}Docs/Read`}>
            <SwaggerUI
              spec={docs}
              docExpansion="list"
              syntaxHighlight={{ activated: false }}
              tryItOutEnabled
              requestInterceptor={async (req) => {
                const token = await getAccessToken();
                req.headers.Authorization = `Bearer ${token}`;
                req.withCredentials = true;

                const siteIdFromRequest = getSiteId(req);
                if (siteIdFromRequest) {
                  siteId = siteIdFromRequest;
                }

                return req;
              }}
              responseInterceptor={(res) => {
                handleBinaryResponse(res, siteId, 'exported_components.xlsx');
                return res;
              }}
            />
          </Can>
        </div>
      </div>
    );
  }
  return (
    <div>
      Documentation for {capitalize(serviceName)} service is currently unavailable. Please try again
      later.
    </div>
  );
};

export default ApiDocView;
